import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ActionTree, GetterTree } from "vuex";
import type { IState } from "@/store";
import type { ApiPathGetter } from "@/models/api";
import { Methods } from "@upmind-automation/types";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => () => {
    const admin = `api/admin/tags`;
    return { admin };
  },
  listScope: () => (brandId: string) => {
    return `$tags_list_${brandId}`;
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath().admin,
        storeModule: DataModules.TAGS
      },
      { root: true }
    );
  },
  get: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/get",
      {
        ...payload,
        path: getters.apiPath().admin,
        storeModule: DataModules.TAGS
      },
      { root: true }
    );
  },
  create: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/create",
      {
        ...payload,
        path: getters.apiPath().admin,
        storeModule: DataModules.TAGS
      },
      { root: true }
    );
  },
  update: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/update",
      {
        ...payload,
        path: `${getters.apiPath().admin}/${payload.id}`,
        storeModule: DataModules.TAGS
      },
      { root: true }
    );
  },
  remove: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/remove",
      {
        ...payload,
        path: `${getters.apiPath().admin}/${payload.id}`,
        storeModule: DataModules.TAGS
      },
      { root: true }
    );
  },
  syncTags: ({ dispatch }, { type, id, tagIds }) => {
    return dispatch(
      "data/callApi",
      {
        method: Methods.PUT,
        path: `api/admin/${type}/${id}/tags`,
        storeModule: DataModules.TAGS,
        requestConfig: {
          data: { tag_ids: tagIds }
        }
      },
      { root: true }
    );
  },
  openAddEditModal: ({ dispatch }, { tag }) => {
    return new Promise<void>(resolve => {
      const modalPromise = dispatch(
        "ui/open/slideModal",
        {
          config: {
            component: () =>
              import("@/components/app/global/tags/tagAddEditModal.vue"),
            width: 540,
            props: {
              tag
            },
            events: {
              success: async () => {
                const modal = await modalPromise;
                modal.close();
                resolve();
              }
            }
          }
        },
        { root: true }
      );
    });
  },
  openManageModal: ({ dispatch }, payload) => {
    return dispatch(
      "ui/open/windowModal",
      {
        config: {
          component: () =>
            import("@/components/app/global/tags/manageTagsModal.vue"),
          width: 440,
          ...payload
        }
      },
      { root: true }
    );
  },
  openManageTagModal: ({ dispatch }, payload) => {
    return dispatch(
      "ui/open/slideModal",
      {
        config: {
          component: () =>
            import("@/components/app/global/tags/manageTagModal.vue"),
          width: 640,
          ...payload
        }
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
